// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderText-module--container--3TimB","title":"HeaderText-module--title--hWQ4k","small_text":"HeaderText-module--small_text--TR8CQ"};